import React, { forwardRef, useImperativeHandle, useState } from 'react';

import type { BlogStructureType } from '../../../../@types/Company';

export interface AppearanceStepHandle {
  isValid: () => boolean;
  getPartialDraft: () => { blogStructure: BlogStructureType; emailSubcontractorName?: string };
  focusFirstInvalid: () => void;
}

interface AppearanceStepProps {
  initial: { blogStructure: BlogStructureType; emailSubcontractorName: string };
  onChange?: (partial: { blogStructure?: BlogStructureType; emailSubcontractorName?: string }) => void;
}

const AppearanceStep = forwardRef<AppearanceStepHandle, AppearanceStepProps>(({ initial, onChange }, ref) => {
  const [blogStructure] = useState<BlogStructureType>(initial.blogStructure);
  const [emailSubcontractorName, setEmailSubcontractorName] = useState(initial.emailSubcontractorName || '');

  useImperativeHandle(ref, () => ({
    isValid: () => (emailSubcontractorName || '').trim().length > 0,
    getPartialDraft: () => ({ blogStructure, emailSubcontractorName }),
    focusFirstInvalid: () => {},
  }), [blogStructure, emailSubcontractorName]);

  return (
    <div>
      <h3 className="mb-4 text-lg font-semibold text-gray-800">Paramétrage du sous-traitant envoi des mails</h3>
      {/* Structure du blog (désactivée pour le moment, valeur par défaut conservée) */}
      {/* <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {(['straight-list', 'alternated-list', 'grid'] as BlogStructureType[]).map(option => (
          <button
            key={option}
            type="button"
            onClick={() => setBlogStructure(option)}
            className={`p-4 border-2 rounded-lg text-left transition-colors ${blogStructure === option ? 'border-rgpd-blue bg-blue-50' : 'border-gray-200 hover:border-gray-300'}`}
          >
            <div className="font-medium text-gray-800 mb-2">
              {option === 'straight-list' && 'Liste simple'}
              {option === 'alternated-list' && 'Liste alternée'}
              {option === 'grid' && 'Grille'}
            </div>
            <div className="h-16 bg-white rounded" />
          </button>
        ))}
      </div> */}

      <div className="mt-8">
        <label className="mb-1 block text-sm font-medium text-gray-700">Sous-traitant d'envoi de mails</label>
        <input
          type="text"
          value={emailSubcontractorName}
          onChange={(e) => {
            const value = e.target.value;
            setEmailSubcontractorName(value);
            if (onChange) { onChange({ emailSubcontractorName: value }); }
          }}
          className="w-full rounded-lg border border-gray-300 p-2.5"
          placeholder="Nom de votre sous-traitant d'envoi de mails"
        />
      </div>
    </div>
  );
});

AppearanceStep.displayName = 'AppearanceStep';

export default AppearanceStep;


